<div class="formulario">
  <div class="container">
    <form class="myForm" [formGroup]="clienteForm" (ngSubmit)="onSubmit()" (keydown.enter)="$event.preventDefault()">
      <div class="container">

        <div class="row">
          <div class="col-lg-6">
            <div class="form-group">
              <label>Nombre</label>
              <input class="form-control" type="text" formControlName="nombre">
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label>Departamento</label>
              <input class="form-control" type="text" formControlName="departamento">
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label>DNI/CIF</label>
              <input class="form-control" type="text" formControlName="cif">
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label>País</label>
              <p-dropdown [options]="countries" formControlName="pais" [showClear]="true" (onChange)="getProvinces($event)" filter="true"></p-dropdown>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label>Provincia</label>
              <p-dropdown [options]="provinces" formControlName="provincia" [showClear]="true" (onChange)="getCities($event)" filter="true"></p-dropdown>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label>Localidad</label>
              <p-dropdown [options]="cities" formControlName="localidad" [showClear]="true" filter="true"></p-dropdown>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label>C.P.</label>
              <input class="form-control" type="text" formControlName="cp">
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label>Dirección</label>
              <input class="form-control" type="text" formControlName="direccion">
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label>Persona de contacto</label>
              <input class="form-control" type="text" formControlName="persona_contacto">
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label>Teléfono</label>
              <input class="form-control" type="text" formControlName="telefono">
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label>Email</label>
              <input class="form-control" type="text" formControlName="email">
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label>Tipo precio facturación</label>
              <p-dropdown [options]="tipoPrecio" formControlName="tipo_precio_facturacion" placeholder="Elige tipo"></p-dropdown>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label>Condición (%)</label>
              <input class="form-control alider" type="number" formControlName="condicion">
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label>Precio/cc transporte</label>
              <input class="form-control alider" type="number" formControlName="precio_cc_transporte">
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label>Precio camión completo</label>
              <input class="form-control alider" type="number" formControlName="precio_camion_completo">
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label>Título campo artículo</label>
              <input class="form-control" type="text" formControlName="titulo_campo_articulo">
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label>Precio comisión por carro mix</label>
              <input class="form-control alider" type="number" formControlName="precio_comision_carro">
            </div>
          </div>
        </div>

        <!-- Fotos -->
        <div class="row mt-4">
          <div class="col-lg-6">
            <div class="form-group">
              <label>Foto 1</label>
              <div class="row">
                <div class="col-8">
                  <input type="file" class="form-control" style="height: 42px !important;"
                    (change)="uploadFile($event, 1)">
                </div>
                <div class="col-1" style="text-align: right;">
                  <button class="btn btn-info" (click)="openCamera(1)" type="button">
                    <i class="fa fa-camera"></i>
                  </button>
                </div>
                <div class="col-1" style="text-align: right; margin-left: 0.5em;">
                  <button class="btn btn-danger" (click)="deleteImagen(1)" type="button">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="form-group text-center" *ngIf="imgURL">
              <p-image [src]="imgURL" [preview]="true" alt="Foto 1" width="250"></p-image>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="form-group">
              <label>Foto 2</label>
              <div class="row">
                <div class="col-8">
                  <input type="file" class="form-control" style="height: 42px !important;"
                    (change)="uploadFile($event, 2)">
                </div>
                <div class="col-1" style="text-align: right;">
                  <button class="btn btn-info" (click)="openCamera(2)" type="button">
                    <i class="fa fa-camera"></i>
                  </button>
                </div>
                <div class="col-1" style="text-align: right; margin-left: 0.5em;">
                  <button class="btn btn-danger" (click)="deleteImagen(2)" type="button">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="form-group text-center" *ngIf="imgURL2">
              <p-image [src]="imgURL2" [preview]="true" alt="Foto 2" width="250"></p-image>
            </div>
          </div>
        </div>

      </div>
      <br>

      <div class="botones">
        <button type="button" class="btn btn-warning" (click)="regresar()"><i class="fa fa-chevron-left"
            aria-hidden="true"></i> Volver</button>
        <button type="submit" class="btn btn-success" [disabled]="clienteForm.invalid || noGrabar"><i
            class="fa fa-save" aria-hidden="true"></i> Enviar</button>
      </div>

    </form>
  </div>
</div>
<p-toast [style]="{marginTop: '80px'}"></p-toast>

<p-dialog [visible]="showCamera">
  <div *ngIf="showCamera">
    <app-camera (sendImage)="getImage($event)" (closeCamera)="closeDialog()" [fileName]="fileName"
      [numberPhoto]="numberPhoto"></app-camera>
  </div>
</p-dialog>
